import { Account } from '@zapier/shared-entities';
import ActionTypes from 'app/dashboard/ActionTypes';
import Data from 'app/dashboard/Data';
import { selectAreHeldReasonsLoading } from 'app/dashboard/Selectors';

const DashboardActions = {
  loadHeldReasons() {
    return (dispatch, getState) => {
      const state = getState();
      const accountId = Account.selectors.all.currentAccountId(state);
      return (
        !selectAreHeldReasonsLoading(state) &&
        dispatch({
          type: ActionTypes.LOAD_HELD_REASONS,
          promise: Data.loadHeldReasons(accountId),
        })
      );
    };
  },
};

export default DashboardActions;
